import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import WhoWeAre from './components/WhoWeAre';
import OurFocus from './components/OurFocus';
import KnowTrace from './components/KnowTrace';
import Philosophy from './components/Philosophy';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <WhoWeAre />
      <OurFocus />
      <KnowTrace />
      <Philosophy />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;